import axiosInstance from '../../../../config/axios';

export interface LightspeedStatus {
  connected: boolean;
  env?: 'trial' | 'prod';
  expires_at?: string;
  last_sync_at?: string;
  error_code?: string;
  error_detail?: string;
  default_business_location_id?: number;
  default_business_location_name?: string;
}

export interface LightspeedBusiness {
  id: number;
  name: string;
  locations: LightspeedBusinessLocation[];
}

export interface LightspeedBusinessLocation {
  id: number;
  name: string;
  business_id: number;
}

export interface LightspeedImportResult {
  sales_count: number;
  from: string;
  to: string;
  total_gross?: number;
  total_net?: number;
  currency?: string;
  errors?: string[];
  request_id?: string;
}

const BASE = '/api/integrations/lightspeed';

class LightspeedService {
  async startConnect(env: 'trial' | 'prod'): Promise<{ authorize_url: string }> {
    const response = await axiosInstance.post<{ authorize_url: string }>(
      `${BASE}/connection/start/`,
      { env }
    );
    return response.data;
  }

  async getStatus(): Promise<LightspeedStatus> {
    const response = await axiosInstance.get<LightspeedStatus>(
      `${BASE}/connection/status/`
    );
    return response.data;
  }

  async disconnect(): Promise<void> {
    await axiosInstance.post(`${BASE}/connection/disconnect/`);
  }

  async getBusinesses(): Promise<LightspeedBusiness[]> {
    const response = await axiosInstance.get<{ businesses: LightspeedBusiness[] } | LightspeedBusiness[]>(
      `${BASE}/businesses/`
    );
    if (Array.isArray(response.data)) return response.data;
    return response.data.businesses ?? [];
  }

  async setDefaultMapping(businessId: number, businessLocationId: number): Promise<void> {
    await axiosInstance.post(`${BASE}/mappings/default/`, {
      business_id: businessId,
      business_location_id: businessLocationId,
    });
  }

  async importSales(businessLocationId: number, from: string, to: string): Promise<LightspeedImportResult> {
    const response = await axiosInstance.post<LightspeedImportResult>(
      `${BASE}/import/sales/`,
      { business_location_id: businessLocationId, from, to }
    );
    return response.data;
  }
}

export default new LightspeedService();
